<template>
  <section class="rules">
    <title-bg></title-bg>
    <h3 class="rules-title">联系我们</h3>
    <ul class="rules-list">
      <li class="rules-list-item">
        <!--<span class="rules-list-item-content">
          <label class="txtjust">联系电话</label><p style="display: inline-block;">：68597714</p>
        </span>
        <span class="rules-list-item-content">
          <label class="txtjust">联系人</label><p style="display: inline-block;">：王老师</p>
        </span>-->
        <span class="rules-list-item-content">
          <p style="display: inline-block;">1.  中关村老年大学地址：海淀区中关村南一街甲5号（甲78号楼对面平房）  <a color="red">电话：62559024</a></p>
        </span>
        <span class="rules-list-item-content">
          <p style="display: inline-block;">2.  中关村活动站地址：海淀区中关村东南小区甲932号楼     <a color="red">电话：62631596  62548001</a></p>
        </span>
        <span class="rules-list-item-content">
          <p style="display: inline-block;">3.  中关村新活动站地址：海淀区中关村东南小区甲932号楼南侧     <a color="red">电话：62423243</a> </p>
        </span>
        <span class="rules-list-item-content">
          <p style="display: inline-block;">4.  三里河校区地址：西城区三里河三区甲7号（三区6号楼与7号楼之间）   <a color="red">电话：68574162</a></p>
        </span>
        <span class="rules-list-item-content">
          <p style="display: inline-block;">5.  科学园南里校区地址：朝阳区大屯路科学园南里三区综合楼       <a color="red">电话：64847476</a></p>
        </span>
      </li>
    </ul>
  </section>
</template>
<script>
import TitleBg from '../../components/TitileBg'
export default {
  components: {
    TitleBg
  },
  data () {
    return {
      ruleList: []
    }
  },
  mounted () {
    //this.getRules();
  },
  methods: {
    /*getRules () {
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api2&a=get_school_rules').then(function (response) {
        if (response.body.status == 1) {
          this.ruleList = response.body.data;
        }
        this.loading = false;
      }, function (reserror) {
        console.log(reserror);
      })
    }*/
  }
}
</script>
<style lang="less" scoped>
.rules{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  &-title{
    margin: 48px 0 25px;
    height:26px;
    line-height: 26px;
    font-size:25px;
    font-weight:400;
    color:rgba(0,77,153,1);
    text-align: center;
  }
  &-list{
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    &-item{
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      &-title{
        margin-bottom: 12px;
        border-left: 4px solid #3588DD;
        padding-left: 20px;
        height: 26px;
        line-height: 26px;
        font-size:18px;
        font-weight:400;
        color:#333;
      }
      &-content{
        font-size:16px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:30px;
        text-align: justify;
      }
    }
  }
}
.txtjust{
  display: inline-block;
  width: 70px;
  text-align: justify;
  text-align-last: justify;
  /*兼容ie*/
  text-justify: distribute-all-lines;
}
</style>
